export default __webpack_public_path__ + "882e2744b19f0ca267fca6d8b596090b.svg";